import { useState } from "react";
import {
  Sparkles,
  Heart,
  Gem,
  Scale,
  HeartCrack,
  TrendingUp,
  Users,
  Home,
  Briefcase,
  HeartHandshake,
  BookOpen,
  Award,
  Star,
  ArrowUpRight,
} from "lucide-react";
import { services } from "@/data/siteContent";
import ServiceDetailModal from "@/components/site/ServiceDetailModal";

const ICONS = {
  Sparkles,
  Heart,
  Gem,
  Scale,
  HeartCrack,
  TrendingUp,
  Users,
  Home,
  Briefcase,
  HeartHandshake,
  BookOpen,
  Award,
  Star,
};

export default function Services() {
  const [active, setActive] = useState(null);

  return (
    <section
      id="services"
      data-testid="services-section"
      className="section relative"
    >
      <div className="container-luxe">
        <div className="reveal max-w-3xl">
          <div className="text-[11px] tracking-[0.4em] uppercase text-gold-light">
            Our Services · सेवाएँ
          </div>
          <h2
            data-testid="services-title"
            className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1.05] text-cream"
          >
            Eighteen ways to{" "}
            <span className="italic font-editorial gold-text">seek</span>{" "}
            clarity.
          </h2>
          <p className="mt-5 text-cream-muted max-w-xl">
            Every consultation is tailored to your birth chart and the specific
            question your soul is asking today. Tap any card to explore in
            depth.
          </p>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {services.map((s, i) => {
            const Icon = ICONS[s.icon] || Star;
            return (
              <button
                key={s.key}
                type="button"
                onClick={() => setActive(s)}
                data-testid={`service-card-${s.key}`}
                className="service-card reveal glass rounded-2xl p-7 group text-left cursor-pointer focus:outline-none focus:border-[#D4AF37]"
                style={{ transitionDelay: `${i * 30}ms` }}
              >
                <div className="flex items-start justify-between">
                  <div className="w-11 h-11 rounded-full grid place-items-center gold-border">
                    <Icon
                      className="w-5 h-5 text-gold"
                      strokeWidth={1.5}
                    />
                  </div>
                  <ArrowUpRight className="w-5 h-5 text-cream-muted group-hover:text-gold transition-colors duration-500" />
                </div>
                <div className="mt-7 font-devanagari text-gold text-sm tracking-wide">
                  {s.titleHi}
                </div>
                <div className="mt-1 font-display text-lg text-cream leading-tight">
                  {s.title}
                </div>
                <div className="mt-3 text-[13px] text-cream-muted leading-relaxed line-clamp-3">
                  {s.desc}
                </div>
                <div className="mt-6 pt-5 border-t border-white/5 flex items-center justify-between">
                  <span className="text-[11px] tracking-[0.28em] uppercase text-cream-muted">
                    Details
                  </span>
                  <span
                    data-testid={`service-view-${s.key}`}
                    className="text-[11px] tracking-[0.28em] uppercase text-gold group-hover:text-gold-light"
                  >
                    View →
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      <ServiceDetailModal
        service={active}
        open={!!active}
        onOpenChange={(v) => !v && setActive(null)}
      />
    </section>
  );
}
